import { io } from "socket.io-client";

const socket = io(process.env.REACT_APP_URL, {
            withCredentials: true,
            transports: ['websocket'],
            //autoConnect: true,
            query:{
                username: "Saeed",
                isMobile: navigator.userAgentData.mobile
            }
        });

export default socket;